import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useI18nContext } from '@/i18n/i18n-react';
import { AudiencesListPresenter } from '@/components/audiences/audiences-list.presenter';
import { AudienceListHeader } from '@/components/audiences/audience-list-header';
import { mapAudienceSummaryToItem } from '@/components/audiences/map-audience-summary-to-item';
import { useAudiences } from '@/hooks/use-audiences';
import {
  CenteredContent,
  CenteredContentLayout,
} from '@/layouts/centered-content.layout';
import { SidebarLayout } from '@/layouts/sidebar.layout';

export default function AudiencesPage() {
  const tenantSlug = useParams().tenantSlug ?? '';
  const { LL, locale } = useI18nContext();
  const { data, isLoading, error } = useAudiences();

  const audiences = useMemo(
    () => (data ?? []).map(mapAudienceSummaryToItem),
    [data]
  );

  if (isLoading || error) {
    return (
      <SidebarLayout className="!p-0">
        <CenteredContentLayout>
          <AudienceListHeader tenantSlug={tenantSlug} />

          <CenteredContent>
            <div className="text-center py-10">
              <p className="text-muted-foreground">
                {isLoading
                  ? LL.audiences.loadingAudiences()
                  : LL.audiences.failedToLoadAudiences()}
              </p>
            </div>
          </CenteredContent>
        </CenteredContentLayout>
      </SidebarLayout>
    );
  }

  return (
    <AudiencesListPresenter
      audiences={audiences}
      tenantSlug={tenantSlug}
      locale={locale}
    />
  );
}
